import React from "react";

/**
 * Cross icon component
 * @param {Object} props - Component props
 * @param {string} [props.color='black'] - The color of the icon
 * @param {number} [props.size=14] - The size of the icon
 * @param {string} [props.viewBox='7.22 7.22 15.56 15.56'] - The SVG viewBox attribute
 * @returns {React.ReactElement} Cross icon
 */
export const CrossIcon = ({
  color = "black",
  size = 14,
  viewBox = "7.22 7.22 15.56 15.56",
}) => (
  <svg
    width={size}
    height={size}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 13.5858L21.364 7.22183L22.7782 8.63604L16.4143 15L22.7782 21.364L21.364 22.7782L15 16.4142L8.63608 22.7782L7.22187 21.364L13.5858 15L7.22187 8.63604L8.63608 7.22183L15 13.5858Z"
      fill={color}
    />
  </svg>
);
